<template>
  <Form style="line-height:32px"
        :label-width="120"
        inline>
    <FormItem :label="$t('erp.b2c.cancel_type',{defaultValue:'取消类型'})"
              style="width:90%"
              prop="type"
              v-show="dataParam.orderStatus=='picked'&&isEmptyApitype && isAdmin == 1">
      <RadioGroup v-model="type">
        <Radio label="0">{{$t('erp.b2c.cancel_bossorder',{defaultValue:'仅取消BOSS订单'})}}</Radio>
        <Radio label="1">{{$t('erp.b2c.same_cancelwahouse',{defaultValue:'同步取消仓库订单'})}}</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem :label="$t('erp.b2c.cancel_reason',{defaultValue:'取消原因'})"
              style="width:90%"
              prop="remark">
      <Input v-model="remark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <div class="color-error text-left"
         style="margin-left: 60px;line-height: 20px; width: 80%"
         v-show="dataParam.orderStatus=='picked'&&isEmptyApitype && isAdmin == 1">
      <div v-html="$t('erp.b2c.cancel_notes')"></div>
    </div>
    <div v-if="isAdmin == 0"
         class="color-error text-left"
         style="margin-left: 60px;line-height: 20px; width: 80%">
      <div v-html="$t('erp.b2c.cancel_notes2', { defaultValue: '已配货状态取消订单会向erp系统对接的仓库请求取消，erp系统没有对接的仓库无法保证成功取消。' })"></div>
    </div>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import { HttpCancelOrder } from '@/service/boss/b2corder'
import { mapState } from 'vuex'
export default {
  props: ['dataParam', "warehouseList", "isAdmin"],
  data () {
    return {
      loading: false,
      show: true,
      remark: '',
      type: "1",
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
    }
  },
  computed: {
    isEmptyApitype () {
      const id = this.dataParam.orgWarehouseId,
        result = this.warehouseList.filter((item) => {
          return item.value == id;
        })[0] || {};
      // console.log(result)
      var arr = Object.keys(result);
      if (arr.length > 0 && result.attach.apiType == "") {
        this.type = "0"
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      this.loading = true;
      HttpCancelOrder({
        orderId: this.dataParam.id,
        cancelType: this.type,
        remark: this.remark,
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

